<p>Statistic works!</p>
